export default "__VITE_ASSET__DIJ8rA____"